// flow
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import format from 'date-fns/format'
import { User } from '../../types'
import { fetchTours } from '../../actions/user'
import Table from '../../components/Table'
import Tr from '../../components/Tr'
import Th from '../../components/Th'
import Td from '../../components/Td'
import Blockquote from '../../components/Blockquote'

type Props = {
  user: User,
  fetchTours: Function,
  tours: Array<Object>
}

class UserTours extends Component {
  componentDidMount() {
    this.props.fetchTours(this.props.user.id)
  }

  props: Props

  render() {
    return (
      <div>
        <Helmet title="Tours" />
        <Blockquote style={{ marginBottom: '2rem' }}>
          Scheduled tours will appear here.{' '}
          <Link to="/properties"> Browse our properties</Link> to begin
          searching.
        </Blockquote>
        <Table>
          <thead>
            <Tr>
              <Th>MLS#</Th>
              <Th>Date</Th>
              <Th>Time</Th>
              <Th>Method</Th>
            </Tr>
          </thead>
          <tbody>
            {this.props.tours.map((tour) => (
              <Tr key={tour.id}>
                <Td>
                  <Link to={`/properties/${tour.mls_id}`}>
                    {tour.listing_id}
                  </Link>
                </Td>
                <Td>{format(tour.date, 'MM/DD/YYYY')}</Td>
                <Td>{tour.time}</Td>
                <Td>{tour.method}</Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.session.currentUser,
    tours: state.user.tours
  }),
  {
    fetchTours
  }
)(UserTours)



// WEBPACK FOOTER //
// ./src/views/UserTours/index.js